export const getStyled = (theme) => ({
  root: {
    width: '100%',
    padding: '2px',
  },
  mainPaper: {
    width: '100%',
    flex: 1,
    backgroundColor: theme.custom.colors.defaultBackground,

    borderColor: theme.palette.mode === 'light' ? '#192734' : '#8C939A',
    color: ` ${theme.custom.colors.text} !important`,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiIconButton-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiAvatar-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },

  fullWidth: {
    width: '100%',
  },

  tableContainer: {
    width: '100%',
    padding: 5,
    ...theme.custom.scrollbarStyles,
    backgroundColor: theme.custom.colors.defaultBackground,
  },

  textRight: {
    textAlign: 'right',
  },

  buttonContainer: {
    textAlign: 'right',
  },
});
